import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';

import { loadProductsByBrand } from '../../../redux/modules/products';

import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';
import { primary_dark15, primary_light } from '../../shared/lib/colors';

import '../Categoria/Categoria.scss';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { ImageDispatcher } from '../../shared/ImageDispatcher/ImageDispatcher.js';

class Brand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    // GA4 TRACK LIST
    if (this.props.hasGoogleAnalytics4Advanced) {
      this.ga4TrackItemsList();
    }

    // FKMX TRACK LIST
    if (this.props.hasFarmakomMetrics) {
      this.fkmxTrackItemsList();
    }
  }

  componentDidUpdate(oldProps, prevProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      // GA4 TRACK LIST
      if (this.props.hasGoogleAnalytics4Advanced) {
        this.ga4TrackItemsList();
      }

      // FKMX TRACK LIST
      if (this.props.hasFarmakomMetrics) {
        this.fkmxTrackItemsList();
      }
    }
  }

  ga4TrackItemsList = () => {
    const { products } = this.props;
    const { brand } = this.props.params;

    const ga4ListInfo = {
      id: `brand_${brand}`,
      name: `brand > ${brand}`,
    };

    ga4ViewItemList(products, ga4ListInfo);
  };

  fkmxTrackItemsList = () => {
    const { products } = this.props;
    const { brand } = this.props.params;

    const fkmxListInfo = {
      id: `brand_${brand}`,
      name: `brand > ${brand}`,
    };

    fkmxViewItemList(products, fkmxListInfo);
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts(isMobile) {
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { brand } = this.props.params;
    const ga4ListInfo = {
      id: `brand_${brand}`,
      name: `brand > ${brand}`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div
              className="col-sm-6 col-lg-4 col-xl-3"
              key={product.id}
              style={{ padding: 0 }}
            >
              <ProductThumbnail
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                productsThumbnail={this.props.productsThumbnail}
                product={product}
                list="tag"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { brand } = this.props.params;
    const ga4ListInfo = {
      id: `brand_${brand}`,
      name: `brand > ${brand}`,
    };

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  primaryColor={this.props.primaryColor}
                  secondaryColor={this.props.secondaryColor}
                  productsThumbnail={this.props.productsThumbnail}
                  key={product.id}
                  product={product}
                  list="tag"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                  lazy={index >= 4}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { brand } = this.props.params;
    const {
      location,
      pagination,
      products,
      tagName,
      loading,
      siteName,
      siteUrl,
      logoImage,
      primaryColor,
      secondaryColor,
      uiVariantButton,
    } = this.props;

    const capitalizeFirst = string =>
      string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    const brandName = brand
      ? capitalizeFirst(brand)
          .split('-')
          .map(capitalizeFirst)
          .join(' ')
      : '';

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`${brandName} online`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${brandName}`,
            },
            {
              name: 'keywords',
              content: `${brandName}, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${brandName}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${brandName}`,
            },
            { property: 'og:image', content: logoImage },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/brand/${(brandName || '')
                .toLowerCase()
                .replace(/\s+/g, '-')}${
                pagination.page > 1 ? `?page=${pagination.page}` : ''
              }`,
            },
          ]}
        />

        <div className="container">
          <LeftFilters
            location={location}
            sort={location.query.sort || 'sales'}
          />
          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle desktop"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="brand" brand={brand} brandName={brandName} />

              {products.length > 0 && pagination.totalPages > 1 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                display: 'flex',
                alignItems: 'center',
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius: 12,
              }}
            >
              <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 0 }}>
                {brandName}
              </h1>
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
              {this.props.categoryType &&
                this.props.categoryType.toLowerCase() === 'farmaci' &&
                !!linkDrugsAuthorizedSite && (
                  <div style={{ float: 'right' }}>
                    <a
                      className="store-authorized-link"
                      href={linkDrugsAuthorizedSite}
                      target="_blank"
                      aria-label="Link all'autorizzazione ministeriale della farmacia"
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_autorizzata.png"
                        style={{ width: 60 }}
                        alt="Logo farmacia autorizzata"
                      />
                    </a>
                  </div>
                )}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">
                  {this.renderProducts(this.props.isMobile)}
                </div>

                {pagination.totalPages > 1 && (
                  <Pager
                    location={location}
                    page={location.query.page || 1}
                    totalPages={pagination.totalPages}
                    sort={location.query.sort || 'sales'}
                    primaryColor={primaryColor}
                    uiVariantButton={uiVariantButton}
                    isNew
                  />
                )}
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto trovato per questo brand.</p>
                <p>Prova a ricercare per parole chiave.</p>
              </div>
            )}
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasCriteo: state.store.data.features.hasCriteo,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
  };
}

export default withRouter(
  connect(mapStateToProps)(connectDataFetchers(Brand, [loadProductsByBrand]))
);
